import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid2";
import * as React from "react";
import { useNavigate } from "react-router-dom";
import { SearchResponseModel, InvoiceStatus } from "@attelas/shared";
import { useInvoicesByCustomerOrId } from "../../../hooks/useInvoicesByCustomerOrId";
import { ChasablesContext } from "../../../context/ChasablesContext";
import { InvoiceSelect } from "../InvoiceSelect";
import { InvoiceTotalInfo } from "../../../components/InvoiceTotalInfo";

export function SearchInvoiceSelect(props: {
  value: SearchResponseModel;
  selectedInvoiceIds: string[];
  setSelectedInvoiceIds: (ids: string[]) => void;
  fullHeight?: boolean;
}) {
  const { value, selectedInvoiceIds, setSelectedInvoiceIds, fullHeight = false } = props;
  const { chasables } = React.useContext(ChasablesContext);
  const { invoices, totalInfo, isLoading } = useInvoicesByCustomerOrId(value);
  const validInvoices = invoices?.filter(({ status }) => {
    return status !== InvoiceStatus.DELETED && status !== InvoiceStatus.VOIDED;
  });
  const isDataLoading = isLoading || !chasables;
  const navigate = useNavigate();

  const navigateToChasable = (event: React.MouseEvent<HTMLElement, MouseEvent>, invoiceId: string) => {
    event.preventDefault();

    if (invoiceId) {
      navigate(`/chasables/suggested/${invoiceId}?isFromSearch=true&showBackButton=true`);
    }
  };

  React.useEffect(() => {
    if (!isDataLoading) {
      const actions =
        invoices?.filter(({ id }) => {
          return !!chasables?.actions.find((action) => action.externalId === id);
        }) ?? [];
      setSelectedInvoiceIds(actions.map(({ id }) => id));
    }
  }, [isDataLoading]);

  if (isLoading) {
    return (
      <Grid container justifyContent="center" alignItems="center" size="grow">
        <CircularProgress />
      </Grid>
    );
  }

  if (!validInvoices?.length) return null;

  return (
    <>
      {totalInfo && (
        <InvoiceTotalInfo
          totalAmount={totalInfo.totalAmount}
          totalDueAmount={totalInfo.totalDueAmount}
          link={totalInfo.link}
        />
      )}
      <Grid size={12} borderRadius="4px" border="1px solid #c7c7c7" overflow="hidden">
        <InvoiceSelect
          selectable={true}
          disabled={isDataLoading}
          showTableOnly={true}
          invoices={validInvoices ?? []}
          selectedInvoiceIds={selectedInvoiceIds}
          onSelectChange={setSelectedInvoiceIds}
          onInvoiceClick={navigateToChasable}
          tableStyle={{ "tr > th:last-of-type,td:last-of-type": { pr: 2 } }}
          fullHeight={fullHeight}
        />
      </Grid>
    </>
  );
}
